
import { FormGroup, FormControl, FormArray, Validators } from '@angular/forms';
import { WorkStornoItemToStockDto } from '../models/work-storno-item-to-stock-dto';

export function getSetProjectToStornoDtoFormGroup() {
return new FormGroup({
    reasontypeId: new FormControl<number | undefined>(undefined),
    notes: new FormControl<string | undefined>(undefined),
    clearSaleAndRevenue: new FormControl<boolean | undefined>(true),
    clearInstallationDates: new FormControl<boolean | undefined>(true),
    clearTeam: new FormControl<boolean | undefined>(true),
    archiveTasks: new FormControl<boolean | undefined>(true),
    archiveAppointments: new FormControl<boolean | undefined>(true),
    removeExternalAppointments: new FormControl<boolean | undefined>(true),
    unlinkProjects: new FormControl<boolean | undefined>(true),
    itemsToBookToStock: new FormControl<WorkStornoItemToStockDto[]>([]),
    removeItemsFromOrdercarts: new FormControl<boolean | undefined>(false),
    releaseSerialnumbers: new FormControl<boolean | undefined>(false),
    unlockProject: new FormControl<boolean | undefined>(true),
    closeProject: new FormControl<boolean | undefined>(true),
    resetContactCategory: new FormControl<boolean | undefined>(false),
    debtorIdsToDelete: new FormControl<Array<number> | undefined>([]),
    sendNotificationMail: new FormControl<boolean | undefined>(true),
    additionalMailRecipients: new FormControl<Array<string> | undefined>([]),
})
;
}
      